import React from 'react';

import Hospital from '../hospital';
import HospitalTable from '../hospital-table';

import ActiveHospital from '../activeHospital';
import ActiveHospitalTable from '../activeHospital-table';

import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';

import HospitalizationMapIndex from '../hospitalizationMap/hospitalizationMapIndex';
import OverviewTables from '../overview/overviewTables';
import ReducedData from '../../reducedData.json';
import OnThisPage from '../onThisPage/onThisPage';
import dict from '../../dictionary';
var covidData = ReducedData.covidData;
const latest = covidData[covidData.length - 1];
const previous = covidData[covidData.length - 2];
const totalSince = 'Jan 15, 2020';

const Hospitals = (props) => {
  const stats = {
    curr: [
      {
        label: trans.hospital.hospitalized[props.lang],
        value: latest[dict.patientHospitalizedCOVID19],
        difference:
          latest[dict.patientHospitalizedCOVID19] -
          previous[dict.patientHospitalizedCOVID19],
      },
      {
        label: trans.overview.icuAbbr[props.lang],
        value: latest[dict.patientsICUwCOVID19],
        difference:
          latest[dict.patientsICUwCOVID19] -
          previous[dict.patientsICUwCOVID19],
      },
      {
        label: trans.hospital.ventilator[props.lang],
        value: latest[dict.patientsICUventilatorwCOVID19],
        difference:
          latest[dict.patientsICUventilatorwCOVID19] -
          previous[dict.patientsICUventilatorwCOVID19],
      },
    ],
  };
  return (
    <>
      <OverviewTables
        stats={stats}
        lang={props.lang}
        totalSince={totalSince}
        lastUpdated={props.momentBuildTime}
        withLegend={true}
        labels={[trans.overview.inHospital[props.lang]]}
        descs={[trans.overview.currently[props.lang]]}
      />
      <OnThisPage
        lang={props.lang}
        sections={[
          {
            href: '#byArea',
            category: 'otp',
            text: 'byArea',
          },
          {
            href: '#activeAndHospitalized',
            category: 'otp',
            text: 'activeAndHospitalized',
          },
          {
            href: '#hospitalizedAndICU',
            category: 'otp',
            text: 'hospitalizedAndICU',
          },
          {
            href: '#hospitals_data',
            category: 'otp',
            text: 'hospitals_data',
          },
        ]}
      />

      <div className="ontario-row">
        <SectionHeader
          id="byArea"
          title={trans.otp.byArea}
          lastUpdated={props.lastUpdated}
          lang={props.lang}
        >
          <Infographic
            id=""
            lang={props.lang}
            defaultSelection="chart"
            width="full"
            opts={['chart']}
            chart={<HospitalizationMapIndex lang={props.lang} />}
          />
        </SectionHeader>
        <SectionHeader
          id="activeAndHospitalized"
          title={trans.otp.activeAndHospitalized}
          lastUpdated={props.lastUpdated}
          lang={props.lang}
        >
          <Infographic
            id="InICU"
            lang={props.lang}
            titleDesc={{
              desc: trans.hospital.activeDesc,
            }}
            bar={
              <ActiveHospital
                lang={props.lang}
                chartTitle={trans.hospital.active[props.lang]}
              />
            }
            width="full"
            table={<ActiveHospitalTable lang={props.lang} />}
          />
        </SectionHeader>
        <SectionHeader
          id="hospitalizedAndICU"
          title={trans.otp.hospitalizedAndICU}
          lastUpdated={props.lastUpdated}
          lang={props.lang}
        >
          <Infographic
            id="Hospital"
            lang={props.lang}
            titleDesc={{
              desc: trans.hospital.hospitalDesc,
            }}
            width="full"
            bar={
              <Hospital
                lang={props.lang}
                chartTitle={trans.hospital.title[props.lang]}
              />
            }
            table={<HospitalTable lang={props.lang} />}
          />
        </SectionHeader>
      </div>
    </>
  );
};

export default Hospitals;
